import React, { useState } from 'react';

export default function CreatorFooter() {
  const [showModal, setShowModal] = useState(false);

  // URL de ta photo dans `public/images/yanis.jpg` (dépose le fichier dans public/images)
  const creatorAvatar = '/images/yanis.jpg'; // remplace par .png si nécessaire

  const socials = [
    { name: 'Twitter', icon: '𝕏', url: 'https://twitter.com', class: 'twitter' },
    { name: 'GitHub', icon: '⚙️', url: 'https://github.com', class: 'github' },
    { name: 'LinkedIn', icon: '💼', url: 'https://linkedin.com', class: 'linkedin' },
    { name: 'Instagram', icon: '📸', url: 'https://instagram.com', class: 'instagram' }
  ];

  return (
    <>
      <div className="creator-footer" onClick={() => setShowModal(true)}>
        <div className="creator-avatar">
          <img
            src={creatorAvatar}
            alt="Yanis Mezaber"
            onError={(e) => {
              e.currentTarget.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"%3E%3Crect fill="%233b82f6" width="100" height="100"/%3E%3Ctext x="50" y="60" font-size="50" fill="white" text-anchor="middle" font-weight="bold"%3EYM%3C/text%3E%3C/svg%3E';
            }}
          />
        </div>
        <div className="creator-badge">👨‍💻</div>
      </div>

      {showModal && (
        <div className="creator-modal-backdrop" onClick={() => setShowModal(false)}>
          <div className="creator-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="creator-modal-close"
              onClick={() => setShowModal(false)}
            >
              ✕
            </button>

            <div className="creator-modal-avatar">
              <img
                src={creatorAvatar}
                alt="Yanis Mezaber"
                onError={(e) => {
                  e.currentTarget.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"%3E%3Crect fill="%233b82f6" width="100" height="100"/%3E%3Ctext x="50" y="60" font-size="50" fill="white" text-anchor="middle" font-weight="bold"%3EYM%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>

            <h2>Yanis Mezaber</h2>
            <div className="creator-modal-title">Créateur de Mon Dashboard</div>

            <div className="creator-modal-bio">
              Bienvenue sur l'ensemble de mes applications et projets disponibles en ligne.
              <br />
              <br />
              Développeur passionné créant des outils web modernes et intuitifs pour centraliser vos ressources.
            </div>

            <div className="creator-socials">
              {socials.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`social-link ${social.class}`}
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>

            <button
              className="btn btn-primary"
              onClick={() => setShowModal(false)}
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </>
  );
}
